import { ModeSettingEnum } from '@colonist/game-base-types';
import { CardDataController } from '@colonist/game-card-types';
import { CardTypeEnum } from '@colonist/game-states';
export class BankCardUtils {
    static resourceCardCountFor(setting, cardType) {
        switch(cardType){
            case CardTypeEnum.Resource:
                return BankCardUtils.resourceCardCountForResourceCards(setting);
            case CardTypeEnum.Commodity:
                return BankCardUtils.resourceCardCountForCommiditiesCards(setting);
            default:
                return 19;
        }
    }
    static resourceCardCountForResourceCards(setting) {
        switch(setting){
            case ModeSettingEnum.Seafarers4P:
            case ModeSettingEnum.CitiesAndKnights4P:
            case ModeSettingEnum.CitiesAndKnightsSeafarers4P:
            case ModeSettingEnum.Classic4P:
                return 19;
            case ModeSettingEnum.Seafarers56P:
            case ModeSettingEnum.CitiesAndKnights56P:
            case ModeSettingEnum.CitiesAndKnightsSeafarers56P:
            case ModeSettingEnum.Classic56P:
                return 24;
            case ModeSettingEnum.Classic78P:
                return 29;
            default:
                return 19;
        }
    }
    static resourceCardCountForCommiditiesCards(setting) {
        switch(setting){
            case ModeSettingEnum.Seafarers4P:
            case ModeSettingEnum.CitiesAndKnights4P:
            case ModeSettingEnum.CitiesAndKnightsSeafarers4P:
            case ModeSettingEnum.Classic4P:
                return 12;
            case ModeSettingEnum.Seafarers56P:
            case ModeSettingEnum.CitiesAndKnights56P:
            case ModeSettingEnum.CitiesAndKnightsSeafarers56P:
            case ModeSettingEnum.Classic56P:
                return 18;
            case ModeSettingEnum.Classic78P:
                return 24;
            default:
                return 12;
        }
    }
    static getStartingResourceCardsForBankState(modeSetting, activeResourceCardTypes) {
        const startingResourceCards = {};
        const allActiveResourceCards = CardDataController.getCardEnumsOfTypes(activeResourceCardTypes);
        for (const activeResourceCard of allActiveResourceCards){
            const cardData = CardDataController.getCardDataForCard(activeResourceCard);
            if (cardData == undefined) continue;
            const totalAmountOfResourcesForMode = BankCardUtils.resourceCardCountFor(modeSetting, cardData.cardTypeEnum);
            startingResourceCards[activeResourceCard] = totalAmountOfResourcesForMode;
        }
        return startingResourceCards;
    }
}
